module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "凭证/附件展示",
      "width": "80%",
      "footer-hide": true
    },
    on: {
      "on-visible-change": _vm.handleModalVisibleChange
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [
    [_c('div', {
      staticClass: "carousel-container"
    }, [_c('el-carousel', {
      ref: "carousel",
      attrs: {
        "indicator-position": "outside",
        "initial-index": _vm.initialIndex
      }
    }, _vm._l((_vm.showList), function(item, index) {
      return _c('el-carousel-item', {
        key: item,
        staticClass: "carousel-item"
      }, [_c('img', {
        staticClass: "preview-image",
        attrs: {
          "src": item,
          "alt": 'Image ' + (index + 1)
        },
        on: {
          "click": function($event) {
            return _vm.handleImageClick(index)
          }
        }
      })])
    }), 1)], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showViewer),
        expression: "showViewer"
      }],
      staticClass: "image-viewer-wrapper",
      on: {
        "click": _vm.closeViewer
      }
    }, [_c('img', {
      staticClass: "viewer-image",
      attrs: {
        "src": _vm.currentImage
      },
      on: {
        "touchstart": _vm.handleTouchStart,
        "touchmove": _vm.handleTouchMove,
        "touchend": _vm.handleTouchEnd
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "viewer-toolbar"
    }, [_c('button', {
      staticClass: "viewer-button",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.closeViewer.apply(null, arguments)
        }
      }
    }, [_vm._v("关闭")])])])]
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37839aaa","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/ShowImageCarousel.vue
// module id = 1755
// module chunks = 8